module.exports = __webpack_public_path__ + "static/media/54_1114.a255ac2b.webp";